
import { useAppContext } from "@src/contexts/App/AppContext";
import SearchForm from "@src/components/SearchForm";
import PopUp from "./components/PopUp";

const App = () => {

    //const [appState, AppActions] = useAppContext();

    return (
        <>
            <SearchForm />
            <PopUp />
        </>
    );
}

export default App;